import { useQuery } from "@tanstack/react-query";
import apiClient from "./apiClient";

const getSliderData = async (limit) => {
  const url = `api/slider`;
  const { data } = await apiClient.get(url);
  return data?.slice(0, limit);
};

const useGetSliders = (limit) => {
  return useQuery({
    queryKey: ["sliders", limit],
    queryFn: () => getSliderData(limit),
    staleTime: 1000 * 60 * 60 * 2, // Cache for 2 hours
    cacheTime: 1000 * 60 * 60 * 2, // Keep cache for 2 hours
  });
};

export default useGetSliders;
